<template>
  <div class="custom-alert">
    <div class="custom-alert-icon-box">
      <i :class="icon" :style="{ color: active ? '#268EA6' : '#F69656' }"></i>
    </div>
    <div class="custom-alert-message-area">
      <h3>{{title}}</h3>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {

  props: ["icon","title", "message", "active"],
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    }
  }
};
</script>

<style scoped lang="less">
.custom-alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 10px;
  background: #e8ebef;
  border-radius: 12px;
  width: 100%;
  .custom-alert-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #ffffff;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: center;
    i {
      font-size: 20px;
    }
  }
  .custom-alert-message-area {
    display: flex;
    flex-direction: column;
    h3 {
      margin: 0;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #292f3b;
    }
    p {
      margin: 0;
      font-weight: 400;
      font-size: 12px;
      word-break: break-word;
      color: #505763;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomAlert.vue